import { render, staticRenderFns } from "./commonUploadDel.vue?vue&type=template&id=94da6dca&scoped=true&"
import script from "./commonUploadDel.vue?vue&type=script&lang=js&"
export * from "./commonUploadDel.vue?vue&type=script&lang=js&"
import style0 from "./commonUploadDel.vue?vue&type=style&index=0&id=94da6dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94da6dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94da6dca')) {
      api.createRecord('94da6dca', component.options)
    } else {
      api.reload('94da6dca', component.options)
    }
    module.hot.accept("./commonUploadDel.vue?vue&type=template&id=94da6dca&scoped=true&", function () {
      api.rerender('94da6dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/commonUploadDel.vue"
export default component.exports